<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="5" />

    <div class="contact-page">

      <!-- Header -->
      <div class="contact-header">
        <div class="contact-header-icon">
          <span class="material-symbols-outlined">contact_support</span>
        </div>
        <div>
          <h2 class="contact-titulo">Información de Contacto</h2>
          <p class="contact-subtitulo">Estamos disponibles para ayudarte con cualquier consulta sobre el sistema</p>
        </div>
      </div>

      <!-- Tarjeta principal -->
      <div class="contact-card">
        <div class="contact-avatar">
          <span class="material-symbols-outlined">support_agent</span>
        </div>
        <div class="contact-nombre">{{ contact.name }}</div>
        <div class="contact-rol">{{ contact.rol }}</div>

        <div class="contact-divider"></div>

        <!-- Items de contacto -->
        <div class="contact-items">
          <a :href="'mailto:' + contact.email" class="contact-item">
            <div class="contact-item-icon contact-item-icon--email">
              <span class="material-symbols-outlined">mail</span>
            </div>
            <div class="contact-item-info">
              <span class="contact-item-label">Correo electrónico</span>
              <span class="contact-item-value">{{ contact.email }}</span>
            </div>
            <span class="material-symbols-outlined contact-item-arrow">open_in_new</span>
          </a>

          <a :href="'tel:' + contact.phone" class="contact-item">
            <div class="contact-item-icon contact-item-icon--phone">
              <span class="material-symbols-outlined">phone</span>
            </div>
            <div class="contact-item-info">
              <span class="contact-item-label">Teléfono</span>
              <span class="contact-item-value">{{ contact.phone }}</span>
            </div>
            <span class="material-symbols-outlined contact-item-arrow">open_in_new</span>
          </a>

          <div class="contact-item contact-item--static">
            <div class="contact-item-icon contact-item-icon--address">
              <span class="material-symbols-outlined">location_on</span>
            </div>
            <div class="contact-item-info">
              <span class="contact-item-label">Dirección</span>
              <span class="contact-item-value">{{ contact.address }}</span>
            </div>
          </div>

          <div class="contact-item contact-item--static">
            <div class="contact-item-icon contact-item-icon--hours">
              <span class="material-symbols-outlined">schedule</span>
            </div>
            <div class="contact-item-info">
              <span class="contact-item-label">Horario de atención</span>
              <span class="contact-item-value">{{ contact.horario }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Nota informativa -->
      <div class="contact-nota">
        <span class="material-symbols-outlined" style="font-size:16px;flex-shrink:0">info</span>
        <span>Para soporte técnico urgente relacionado con el sistema, comunícate directamente por teléfono en horario de atención.</span>
      </div>

    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { ref } from 'vue'

export default {
  name: 'ContactInfo',
  components: { Layout, Footer },

  setup() {
    const contact = ref({
      name:    'Soporte Kiatros',
      rol:     'Equipo de Soporte Técnico',
      address: '1234 Sunset Blvd, Ciudad, País',
      phone:   '+1 234-567-8900',
      email:   'soporte@kiatros.com',
      horario: 'Lunes a viernes, 08:00 – 17:00',
    })
    return { contact }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
}
</script>

<style scoped>
.contact-page {
  max-width: 520px;
  margin: 0 auto;
  padding: 1.5rem 1rem 3rem;
}

/* Header */
.contact-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 1.5rem;
}
.contact-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #185FA5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.contact-header-icon .material-symbols-outlined {
  font-size: 26px;
  color: #E6F1FB;
}
.contact-titulo {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 2px;
}
.contact-subtitulo {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0;
}

/* Tarjeta */
.contact-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 2rem 1.5rem 1.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,.06);
  text-align: center;
  margin-bottom: 1rem;
}
.contact-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #E6F1FB;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.contact-avatar .material-symbols-outlined {
  font-size: 32px;
  color: #185FA5;
}
.contact-nombre {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 4px;
}
.contact-rol {
  font-size: .825rem;
  color: #6c757d;
  margin-bottom: 0;
}
.contact-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 1.25rem 0;
}

/* Items */
.contact-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}
.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  text-decoration: none;
  color: inherit;
  transition: background .15s, border-color .15s;
}
.contact-item:not(.contact-item--static):hover {
  background: #E6F1FB;
  border-color: #B5D4F4;
  cursor: pointer;
}
.contact-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.contact-item-icon .material-symbols-outlined { font-size: 18px; }
.contact-item-icon--email   { background: #E6F1FB; color: #185FA5; }
.contact-item-icon--email .material-symbols-outlined { color: #185FA5; }
.contact-item-icon--phone   { background: #D1FAE5; }
.contact-item-icon--phone .material-symbols-outlined { color: #065F46; }
.contact-item-icon--address { background: #FEF3C7; }
.contact-item-icon--address .material-symbols-outlined { color: #92400E; }
.contact-item-icon--hours   { background: #EDE9FE; }
.contact-item-icon--hours .material-symbols-outlined  { color: #5B21B6; }

.contact-item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.contact-item-label {
  font-size: 11px;
  color: #9aa0ac;
  text-transform: uppercase;
  letter-spacing: .04em;
  font-weight: 500;
}
.contact-item-value {
  font-size: .875rem;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.contact-item-arrow {
  font-size: 15px;
  color: #9aa0ac;
  flex-shrink: 0;
}

/* Nota */
.contact-nota {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: .8rem;
  color: #6c757d;
  line-height: 1.5;
}

@media (max-width: 576px) {
  .contact-page { padding: 1rem .5rem 2rem; }
}
</style>